import { createSelector } from 'reselect'

const getPostmarkSettingsOptions: SelectOptionsSelector = (state) =>
  state.postmarkSettings.postmarkSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const postmarkSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getPostmarkSettingsOptions, (options) => options)
